import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['header']

  initialize() {
    this.hideUntilScroll = this.element.dataset.hideStickyUntilScroll === "true"
    this._createSpacerElement()
    this._calculateValues()
    this.headerTarget.getRootNode().querySelector("html").style.setProperty("scroll-padding-top", `${this.headerHeight + 10}px`)
    this.handleSticky()
  }

  handleSticky() {
    if (window.scrollY > this.headerOffset) {
      this._safelyShow()
      this._shiftContentDown()
      this.headerTarget.classList.add("c-sticky-header")
    } else {
      this.headerTarget.classList.remove("c-sticky-header")
      this._safelyHide()
      this._undoContentShift()
    }
  }

  _createSpacerElement(){
    this.spacerElement = this.element.getRootNode().createElement("div")
    // this doesn't really need a class, but it helps with debugging.
    this.spacerElement.classList.add("c-sticky-header_spacer")
    this.element.insertAdjacentElement("afterEnd", this.spacerElement)
  }

  // When the header switches to become `position: fixed`, the content
  // jumps upward because the header is no longer 'taking space' on the page.
  // To account for that, we expand the spacerElement to shift the content back down.
  _shiftContentDown(){
    this.spacerElement.style.height = `${this.element.getBoundingClientRect().height}px`
  }

  _undoContentShift(){
    this.spacerElement.style.height = "0px"
  }

  _calculateValues() {
    if (this.element.dataset.stickyOffset) {
      this.headerOffset = this.element.dataset.stickyOffset
    } else {
      // Briefly show the header to calculate the offset, then hide it again
      this._safelyShow()
      this.headerOffset = this.headerTarget.offsetTop
      this.headerHeight = this.headerTarget.offsetHeight
      this._safelyHide()
    }
  }

  _safelyShow() {
    if (this.hideUntilScroll) { this.headerTarget.classList.remove("u-hide") }
  }

  _safelyHide() {
    if (this.hideUntilScroll) { this.headerTarget.classList.add("u-hide") }
  }
}
